<template>
  <div class="a-r-box">

    <div class="a-r-list">
      <div class="a-r-top-t flex-b-c" style="padding: 0px 8px;">
        <div class="flex-c">
          <span>{{ $t('aci4') }}</span>
          <div style="width: 260px;margin-left: 16px;">
            <scrolling-text :text="$t('acp1')"></scrolling-text>
          </div>
        </div>
        <!-- <el-button size="mini" @click="addAr">新建</el-button> -->
      </div>
      <div class="a-r-list-item">
        <el-collapse v-model="activeName" accordion @change="collapseChange">
          <el-collapse-item :name="index + ''" v-for="(arItem, index) in arList" :key="arItem.ar_id">
            <template #title>
              <div class="flex-b-c" style="width: 100%;">
                <div>
                  <i class="custom-arrow el-icon-arrow-right" :class="{ 'is-active': activeName === '1' }"
                    style="margin-right: 8px;"></i>
                  <span>{{ arItem.ar_name }}</span>
                </div>
                <div @click="(event) => { event.stopPropagation() }">
                  <el-button size="mini" @click="publish(arItem)" type="success">{{ $t('acit2') }}</el-button>
                  <el-button size="mini" @click="addArItem(arItem.ar_id, arItem.ar_name)" type="primary">{{ $t('acit3')
                  }}</el-button>
                  <el-button size="mini" @click="delArTimerplay(arItem.ar_id, 0)" type="danger"
                    style="margin-right: 8px;">{{ $t('acit4') }}</el-button>
                </div>
              </div>
            </template>
            <ul style="margin-left: 16px;">
              <li class="flex-b-c a-r-p-item" :class="{ activate: index === arItemIndex }"
                v-for="(item, index) in arItem.list" :key="item.id" @click="activateProgram(item.id, index)">
                <div class="a-r-p-item-img flex-a-c">
                  <img style="height: 100%;object-fit: contain;" :src="imgRequest(item.action)" alt />
                </div>
                <div class="a-r-p-item-info">
                  <span>{{ $t('actc1') }}: {{ $t(`terminal.action${item.action}`) }}</span>
                  <span>{{ $t('actc2') }}: {{ item.action === 2 || item.action === 3 ? item.value : '--' }}</span>
                </div>
                <div class="a-r-p-item-btn">
                  <el-button size="mini" @click="delArTimerplay(0, item.id)" type="danger">{{ $t('acit4') }}</el-button>
                </div>
              </li>
            </ul>
          </el-collapse-item>
        </el-collapse>
        <add-ar-btn :name="$t('aci4')" @add="addAr"></add-ar-btn>
      </div>
    </div>
    <div class="a-r-info">
      <template v-if="arList.length">
        <div class="a-r-top-t">{{ $t(`terminal.action${arList[activeName].list[arItemIndex].action}`) }}</div>
        <val-set-box>
          <div class="aaic-item">
            <div style="font-size: 14px;color: #606266;">
              {{ $t('cdcp13') }}
            </div>
            <el-select v-model="action" size="mini" style="width: 160px;"
              @change="(val) => { changeValue('action', val) }">
              <el-option v-for="item in command" :key="item.value" :label="$t(item.label)" :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div class="aaic-item">
            <template v-if="action === 2">
              <div style="font-size: 14px;color: #606266;">
                {{ $t('cdcp2') }}
              </div>
              <el-slider v-model="value" style="width: 160px;"
                @change="(val) => { changeValue('value', val) }"></el-slider>
            </template>
            <template v-if="action === 3">
              <div style="font-size: 14px;color: #606266;">
                {{ $t('cdcp1') }}
              </div>
              <el-slider v-model="value" style="width: 160px;"
                @change="(val) => { changeValue('value', val) }"></el-slider>
            </template>
            <template v-if="action === 6">
              <div style="font-size: 14px;color: #606266;">
                {{ $t('terminal.action6') }}
              </div>
              <el-select v-model="value" size="mini" style="width: 160px;"
                @change="(val) => { changeValue('value', val) }">
                <el-option v-for="item in signal" :key="item.value" :label="$t(item.label)" :value="item.value">
                </el-option>
              </el-select>
            </template>
            <div v-if="action === 7 || action === 8" class="flex-d">
              <div class="aaic-item">
                <span style="font-size: 14px;color: #606266;">{{ $t("temporary1") }} </span>
                <div style="border-radius: 4px;overflow: hidden;">
                  <el-checkbox-group v-model="KpbValue" size="mini" @change="(val) => { changeValue('poweControl') }">
                    <el-checkbox-button v-for="item in KpbSwitch" :label="item.index" :key="item.index">{{ item.name
                    }}</el-checkbox-button>
                  </el-checkbox-group>
                </div>
              </div>
              <div class="aaic-item">
                <span style="font-size: 14px;color: #606266;">{{ $t("temporary36") }}</span>
                <el-checkbox-group v-model="PowerValue" size="mini" @change="(val) => { changeValue('poweControl') }">
                  <el-checkbox-button v-for="item in PowerSwitch" :label="item.index" :key="item.index">{{ item.name
                  }}</el-checkbox-button>
                </el-checkbox-group>
              </div>
              <div class="aaic-item">
                <span style="font-size: 14px;color: #606266;">{{ $t("terminal.mulCard") }}</span>
                <el-checkbox-group v-model="CardValue" size="mini" @change="(val) => { changeValue('poweControl') }">
                  <el-checkbox-button v-for="item in CardSwitch" :label="item.index" :key="item.index">{{ item.name
                  }}</el-checkbox-button>
                </el-checkbox-group>
              </div>
            </div>
          </div>
          <div class="aaic-item">
            <div style="font-size: 14px;color: #606266;">
              {{ $t("cbb1") }}
            </div>
            <el-time-picker style="width: 160px;" size="mini" v-model="startTime"
              @change="(val) => { changeValue('startTime', val) }">
            </el-time-picker>
          </div>
          <div class="aaic-item">
            <el-radio-group v-model="isDateLimit" @change="(val) => { changeValue('isDateLimit', val) }">
              <el-radio :label="0">{{
                $t('terminal.noLimit') }}</el-radio>
              <el-radio :label="1">{{
                $t('terminal.speDate') }}</el-radio>
            </el-radio-group>
            <el-date-picker style="width: 386px;" :disabled="isDateLimit == 0" v-model="playDate" type="daterange"
              :range-separator="$t('cdce3')" :start-placeholder="$t('cdce4')" :end-placeholder="$t('cdce5')" size="mini"
              @change="(val) => { changeValue('playDate', val) }">
            </el-date-picker>
          </div>
          <div class="aaic-item">
            <el-radio-group v-model="isWeekLimit" @change="(val) => { changeValue('isWeekLimit', val) }">
              <el-radio :label="0">{{
                $t('terminal.noLimit') }}</el-radio>
              <el-radio :label="1">{{
                $t('terminal.speWeek') }}</el-radio>
            </el-radio-group>

            <el-checkbox-group v-model="validWeek" :disabled="isWeekLimit == 0" size="mini"
              @change="(val) => { changeValue('validWeek', val) }">
              <el-checkbox-button v-for="week in weeks" :label="week" :key="week">{{ $t(week_intl[week]) }}
              </el-checkbox-button>
            </el-checkbox-group>
          </div>
        </val-set-box>
      </template>
    </div>
    <add-dialog :dialogVisible="addArNameDialog" @closeDialog="closeAddArName" :title="$t('aci4')">
      <el-input v-model="arName">
        <template slot="prepend">{{ $t('aci4') }}</template>
      </el-input>
    </add-dialog>
    <schedule :schduleDialog="schduleDialog" @closeSchedule="closeSchedule" ADDEDIT="ADDEDIT">
    </schedule>
    <terminal-list :terminalListDV="terminalListDV" @publishTerminal="publishTerminal" :append="true" :diffIsAppend="1"
      :isPlay="false"></terminal-list>
  </div>
</template>

<script>
// import superClone from '@/assets/scripts/superClone.js';
import AddDialog from '@/components/basics/AddDialog'
import Schedule from '@/components/terminal/children/item/Schedule'
import { reWeekFormatting, reDateFormatting, reTimeFormatting, timeFormatting, weekFormatting, dateFormatting } from "@/assets/scripts/dateFormatting";
import TerminalList from '../../schedule/windows/children/TerminalList';
import AddArBtn from './items/AddArBtn';
import ValSetBox from './items/ValSetBox';
import ScrollingText from './items/ScrollingText';

const command = [
  { value: 2, label: "terminal.conBright", },
  { value: 3, label: "terminal.conVoice", },
  { value: 4, label: "terminal.action9", },
  { value: 5, label: "terminal.action10" },
  { value: 6, label: "terminal.action6" },
  { value: 7, label: 'terminal.action7' },
  { value: 8, label: 'terminal.action8' }
];

const signal = [
  { value: 0, label: '--' },
  { value: 1, label: 'terminal.acVa1' },
  { value: 2, label: 'terminal.acVa2' },
  { value: 3, label: 'terminal.acVa3' }
];

const KpbSwitch = [
  { name: '开关1', index: '11', value: false },
];
const PowerSwitch = [
  { name: '开关1', index: '8', value: false },
  { name: '开关2', index: '9', value: false },
  { name: '开关3', index: '10', value: false }
];
const CardSwitch = [
  { name: '开关1', index: '0', value: false },
  { name: '开关2', index: '1', value: false },
  { name: '开关3', index: '2', value: false },
  { name: '开关4', index: '3', value: false },
  { name: '开关5', index: '4', value: false },
  { name: '开关6', index: '5', value: false },
  { name: '开关7', index: '6', value: false },
  { name: '开关8', index: '7', value: false }
];

const weeks = ['一', '二', '三', '四', '五', '六', '日'];
const week_intl = { '一': 'terminal.Monday', '二': 'terminal.Tuesday', '三': 'terminal.Wednesday', '四': 'terminal.Thursday', '五': 'terminal.Friday', '六': 'terminal.Saturday', '日': 'terminal.Sunday' };

export default {
  name: "Timercom",
  data() {
    return {
      loading: false,
      activeName: '0',
      arItemIndex: 0,
      arList: [],
      apId: 0,
      arName: this.$t('aci4'),
      addArNameDialog: false,
      schduleDialog: false,
      terminalListDV: false,
      arItemName: '',
      arItemId: '',
      isAddArItem: false,
      command,
      signal,
      action: 2,
      startTime: '00:00:00',
      playDate: [],
      isDateLimit: 0,
      isWeekLimit: 0,
      validWeek: [],
      KpbValue: [],
      PowerValue: [],
      CardValue: [],
      KpbSwitch,
      PowerSwitch,
      CardSwitch,
      value: 0,
      weeks,
      week_intl,
      timeoutId: 0,
      arItem: {}
    }
  },
  created() {
    this.getListAr();
  },
  methods: {
    getListAr() {
      this.loading = true;
      this.$http.post(`/admin/AdvancedRelease/listArTimercom`, {}, data => {
        const list = data.list || [];

        if (list.length && ((list.length <= parseInt(this.activeName)) || (this.arList.length < list.length))) {
          const index = list.length - 1;
          this.activeName = index + '';
          this.arItemIndex = 0;
        }
        this.arList = list;
        this.arList.length && this.init(this.arList[this.activeName].list[this.arItemIndex]);
        this.loading = false;
      }).catch(() => {
        this.arList = [];
        this.loading = false;
      });
    },
    collapseChange(val) {
      if (val) {
        this.activeName = val;
        this.arItemIndex = 0;
      }
    },
    activateProgram(id, index) {
      this.arItemIndex = index;
    },
    imgRequest(type) {
      return require(`@/components/advancedRelease/children/image/command_${type}.png`);
    },
    addAr() {
      this.addArNameDialog = true;
      this.isAddArItem = false;
    },
    closeAddArName(Confirm) {
      if (Confirm) {
        this.schduleDialog = true;
      }
      this.addArNameDialog = false;
    },
    closeSchedule(val) {

      if (val && val !== 'cancel') {
        const { action, startTime, dateStart, dateEnd, isDateLimit, isWeekLimit, validWeek, value } = val

        let arId = this.$uuid.v4();
        let arName = this.arName;
        if (this.isAddArItem) {
          arId = this.arItemId;
          arName = this.arItemName;
        }

        this.addArTimercomItem(arId, arName, {
          action,
          dateStart,
          dateEnd,
          isDateLimit: isDateLimit ? 1 : 0,
          startTime,
          validWeek: parseInt(validWeek, 2),
          isWeekLimit: isWeekLimit ? 1 : 0,
          value
        });
      }
      this.schduleDialog = false;
    },
    addArItem(arId, arName) {
      this.arItemName = arName;
      this.arItemId = arId;
      this.isAddArItem = true;
      this.schduleDialog = true;
    },
    addArTimercomItem(arId, arName, data) {
      const arData = {
        ar_id: arId,
        ar_name: arName,
        group_id: this.$cookies.get("group_id"),
        ...data
      };
      this.$http.post("/admin/AdvancedRelease/addArTimercom", arData, data => {
        console.log(data);
        this.getListAr();
      });
      this.schduleDialog = false;
    },
    numberToBinaryArray(num) {
      const binaryStr = num.toString(2).padStart(12, '0');
      return Array.from(binaryStr).map(bit => parseInt(bit, 10));
    },
    init(data) {
      const { action, value, startTime, isDateLimit, isWeekLimit, dateStart, dateEnd, validWeek } = data;
      this.action = action;
      this.value = value;
      if (action === 7 || action === 8) {
        const bList = this.numberToBinaryArray(value);
        this.KpbValue = [];
        this.PowerValue = [];
        this.CardValue = [];
        bList.forEach((val, index) => {
          if (index === 0) {
            val && this.KpbValue.push((11 - index).toString());
          }
          if (index > 0 && index < 4) {
            val && this.PowerValue.push((11 - index).toString());
          }
          if (index > 3) {
            val && this.CardValue.push((11 - index).toString());
          }
        });
      }
      this.startTime = reTimeFormatting(startTime);
      this.isDateLimit = isDateLimit;
      this.isWeekLimit = isWeekLimit;
      this.playDate = [reDateFormatting(dateStart), reDateFormatting(dateEnd)];
      this.validWeek = reWeekFormatting(validWeek);
    },
    changeValue(key, value) {
      let data = {};
      switch (key) {
        case 'startTime':
          data = { startTime: timeFormatting(value) };
          break;
        case 'playDate': {
          const [dateStart, dateEnd] = value;
          data = {
            dateStart: dateFormatting(dateStart),
            dateEnd: dateFormatting(dateEnd)
          };
        }
          break;
        case 'validWeek':
          data = { validWeek: weekFormatting(value) };
          break;

        case 'action': {
          data = { [key]: value };
          if (value === 2 || value === 3) {
            data.value = 50;
          } else {
            data.value = 0;
          }
        }
          break;
        case 'value':
        case 'isDateLimit':
        case 'isWeekLimit':
          data = { [key]: value };
          break;
        case 'poweControl': {
          const calculateBinaryValue = (array) => {
            return array.reduce((sum, bitStr) => sum + Math.pow(2, parseInt(bitStr, 10)), 0);
          }
          const powerSum = calculateBinaryValue(this.PowerValue);
          const cardSum = calculateBinaryValue(this.CardValue);
          const kpbSum = calculateBinaryValue(this.KpbValue);
          data = { value: kpbSum + powerSum + cardSum };
        }
          break;
        default:
          break;
      }

      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
        this.timeoutId = 0;
      }

      const { id } = this.arList[this.activeName].list[this.arItemIndex];

      this.timeoutId = setTimeout(() => {
        this.$http.post("/admin/AdvancedRelease/editArTimercom", {
          id, ...data
        }, () => {
          // console.log(data);

          this.arList[this.activeName].list[this.arItemIndex] = { ...this.arList[this.activeName].list[this.arItemIndex], ...data };
          this.init(this.arList[this.activeName].list[this.arItemIndex]);

        });
      }, 500);

    },
    publish(arItem) {
      this.arItem = arItem;
      this.terminalListDV = true;
    },
    async sendCmd(commands_info, devices_info, type = "set") {

      const { id, ar_name } = this.arItem;
      await this.$http.post("/admin/Publish/countersPublish", {
        device_select_mode: "multiple",
        devices_info: encodeURIComponent(JSON.stringify(devices_info)),
        commands_info: encodeURIComponent(JSON.stringify(commands_info)),
        request_type: type,
        group_id: parseInt(this.$cookies.get("group_id")),
        counters_ids: id,
        publish_name: ar_name
      }, res => {
        console.log(res);
        const { check_state } = res;
        if (check_state === -1) {
          this.$msg({ message: this.$t('actc3'), type: 'success', });
        } else {
          this.$msg({ message: this.$t('actc4'), type: 'warning', });
        }
      }).catch(() => {
        this.$msg({ message: this.$t('actc5'), type: 'warning', });
      });
    },
    async publishTerminal(terminalList) {

      if (terminalList.length === 0) {
        this.terminalListDV = false;
        return;
      }
      let devices_info = [];
      let commands_info = [];
      terminalList.forEach((d) => {
        const { id, sn, type_id, name, system_version } = d;
        devices_info.push({ id, sn, type_id, name, system_version });
      });

      this.arItem.list.forEach((com) => {
        const { action, value, startTime, isDateLimit, isWeekLimit, dateStart, dateEnd, validWeek } = com;
        commands_info.push({
          action,
          value,
          startTime,
          isDateLimit: isDateLimit ? true : false,
          isWeekLimit: isWeekLimit ? true : false,
          dateStart: dateStart.split("-").join("/"),
          dateEnd: dateEnd.split("-").join("/"),
          validWeek
        });
      });

      await this.sendCmd([{ type: 'schedule_setting', data: commands_info }], devices_info);
      this.terminalListDV = false;
    },
    delArTimerplay(arId = 0, ids = 0) {
      this.$http.post("/admin/AdvancedRelease/delArTimercom", { ar_id: arId, ids: ids }, data => {
        console.log(data);
        this.arItemIndex = 0;
        this.getListAr();
      });
    },
  },
  watch: {
    activeName: {
      handler(nd) {
        this.init(this.arList[nd].list[this.arItemIndex]);
      }
    },
    arItemIndex: {
      handler(nd) {
        this.init(this.arList[this.activeName].list[nd]);
      }
    },
  },
  components: {
    AddDialog,
    Schedule,
    TerminalList,
    AddArBtn,
    ValSetBox,
    ScrollingText
  }
}
</script>


<style lang="scss" scoped>
@import './arStyle.scss';

.a-r-box {
  display: flex;
  height: 100%;
}

.a-r-top-t {
  height: 40px;
  line-height: 40px;
  text-align: center;
  border-bottom: 1px solid #409EFF;
}

.a-r-list {
  width: 360px;
  border-radius: 8px;
  background: #fff;
  border: 1px solid #409EFF;
  margin-right: 12px;

  /* 隐藏默认箭头 */
  /deep/ .el-collapse-item__arrow {
    display: none !important;
  }

  /* 自定义箭头样式 */
  .custom-arrow {
    margin-right: 8px;
    transition: transform 0.3s;
  }

  .el-collapse-item__header.is-active .custom-arrow {
    transform: rotate(90deg);
  }

  .a-r-p-item {
    user-select: none;
    height: 60px;
  }

  .a-r-p-item-img {
    width: 88px;
    height: 50px;
    // background-color: #000;
  }

  .a-r-p-item-info {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
  }

  .a-r-p-item-btn {
    width: 60px;
  }

  /* .add-ar-item-c-add {
    background-color: #edfbff;
    width: 100%;
    height: 40px;
    min-height: 40px;
    border-radius: 8px;
    user-select: none;
  } */

  .a-r-list-item {
    height: calc(100% - 56px);
    overflow-y: auto;
    margin: 8px 0px;
  }
}

.a-r-info {
  flex-grow: 1;
  border-radius: 8px;
  background: #fff;
  border: 1px solid #409EFF;
}

/* .a-r-pinfo {
  width: 300px;
  border-radius: 8px;
  background: #fff;
  border: 1px solid #409EFF;
  margin-left: 12px;
  display: flex;
  flex-direction: column;
} */

.aaic-item {
  margin: 8px 0px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}
</style>